import React from 'react';
import Button from "components/elements/Button";
import { IPricingPlan } from "components/pricing/Plan";
import { localIcon } from "components/elements/Icon";
import useTrans from "components/hooks/useTrans";
import Link from "components/base/Link";
import cn from "classnames";
import Text from "components/typography/Text";

type Props = {
    plans: IPricingPlan[],
    isSalesPage: boolean;
};

export default function Plans(props: Props) {
    const { plans, isSalesPage } = props;
    const { t } = useTrans();

    const tagCn = cn(
        "bg-primary-400 text-white",
        "py-1 px-3 rounded-full text-sm mx-auto mb-2"
    );

    return (
        <>
            <div className={"sticky top-10 pt-10 bg-white rounded-2xl z-10 lg:hidden"}>
                <div className={"flex space-x-1 rounded-xl overflow-hidden"}>
                    {plans.map((plan) => (
                        <div
                            className={"py-4 px-3 flex-1 flex-col flex text-center bg-primary-50"}
                            key={plan.id}
                        >
                            <span>{plan.name}</span>
                            {!isSalesPage && (
                                <Link to={"/demo-request"}>
                                    <Button
                                        id={"pricing-plans-" + plan.name + "__try-for-free--mobile"}
                                        variant={"primary"}
                                        size={"extra-small"}
                                        color={"purple"}
                                        className={"mx-auto rounded-xl font-medium"}
                                    >
                                        {t('tryForFree')}
                                    </Button>
                                </Link>
                            )}
                        </div>
                    ))}
                </div>
            </div>
            <div className={"justify-end hidden lg:flex lg:mt-20"}>
                {plans.map((plan) => {
                    const isMostPopular = plan.mostPopular == true;
                    return (
                        <div
                            className={`flex flex-col 2xl:w-72 lg:w-64 px-1 rounded-t-xl py-8 ${plan.mostPopular ? 'bg-primary-25 ' : ''}`}
                            key={plan.id}
                        >
                            {isMostPopular &&
                                <div className={"flex "}>
                                    <span className={tagCn}>
                                        {t('mostPopular')}
                                    </span>
                                </div>
                            }
                            <div className={`flex mx-auto ${!isMostPopular && "mt-9"}`}>
                                <Text
                                    size={'2xl'}
                                    color={'text-gray-900'}
                                    weight={'medium'}
                                    className={'mt-3 mb-4 text-center'}
                                >
                                    {plan.name}
                                </Text>
                            </div>
                            <div className={"flex mx-auto"}>
                                {!isSalesPage && (
                                    <Link to={"/demo-request"}>
                                        <Button
                                            id={"pricing-plans-" + plan.name + "__try-for-free"}
                                            variant={isMostPopular ? "primary" : "secondary"}
                                            size={"large"}
                                            color={"purple"}
                                            className={"mx-auto"}
                                            icon={localIcon("chevron-right", "bg-white")}
                                        >
                                            {t('tryForFree')}
                                        </Button>
                                    </Link>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </>
    );
}